/* Track order (editorial style): opens the tracking page or shows 17TRACK results in the section. */
(function () {
  var ytLoading = null;
  function load17() {
    if (window.YQV5) return Promise.resolve();
    if (ytLoading) return ytLoading;
    ytLoading = new Promise(function (resolve, reject) {
      var sc = document.createElement('script');
      sc.src = 'https://www.17track.net/externalcall.js';
      sc.async = true;
      sc.onload = resolve; sc.onerror = reject;
      document.head.appendChild(sc);
    });
    return ytLoading;
  }
  function init(form) {
    if (form.dataset.ntTrkInit) return;
    form.dataset.ntTrkInit = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="number"]'), err = form.querySelector('.trk__error');
      var n = input.value.trim();
      if (!n) { if (err) err.hidden = false; input.focus(); return; }
      if (err) err.hidden = true;
      if (form.dataset.provider === '17track') {
        var lang = form.dataset.lang || 'en';
        var fallback = 'https://t.17track.net/' + lang + '#nums=' + encodeURIComponent(n);
        load17().then(function () {
          if (!window.YQV5 || !window.YQV5.trackSingle) { window.location.href = fallback; return; }
          window.YQV5.trackSingle({ YQ_ContainerId: form.dataset.result, YQ_Height: +form.dataset.height || 560, YQ_Fc: '0', YQ_Lang: lang, YQ_Num: n });
        }).catch(function () { window.location.href = fallback; });
        return;
      }
      var url = form.dataset.url || 'https://parcelsapp.com/en/tracking/[number]';
      window.open(url.replace('[number]', encodeURIComponent(n)), '_blank', 'noopener');
    });
  }
  function all() { document.querySelectorAll('.trk-ed__form').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
